/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * Ceiling or deductible of a guarantee in the re-pricing model.
 * @export
 * @interface RetarificationParametreDto
 */
export interface RetarificationParametreDto {
    /**
     * Variable value of the tunnel guarantee, as expected by the comparator.
     * @type {string}
     * @memberof RetarificationParametreDto
     */
    variableValueId?: string | null;
    /**
     * Current value on the quote (tunnel default when the guarantee is not selected).
     * @type {number}
     * @memberof RetarificationParametreDto
     */
    valeur?: number | null;
    /**
     * Allowed values, null when the value cannot be changed.
     * @type {ConfigurableParameterDto}
     * @memberof RetarificationParametreDto
     */
    parametres?: ConfigurableParameterDto | null;
}

/**
 * Check if a given object implements the RetarificationParametreDto interface.
 */
export function instanceOfRetarificationParametreDto(value: object): value is RetarificationParametreDto {
    return true;
}

export function RetarificationParametreDtoFromJSON(json: any): RetarificationParametreDto {
    return RetarificationParametreDtoFromJSONTyped(json, false);
}

export function RetarificationParametreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationParametreDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'] == null ? undefined : json['variableValueId'],
        'valeur': json['valeur'] == null ? undefined : json['valeur'],
        'parametres': json['parametres'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parametres']),
    };
}

export function RetarificationParametreDtoToJSON(json: any): RetarificationParametreDto {
    return RetarificationParametreDtoToJSONTyped(json, false);
}

export function RetarificationParametreDtoToJSONTyped(value?: RetarificationParametreDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'valeur': value['valeur'],
        'parametres': ConfigurableParameterDtoToJSON(value['parametres']),
    };
}

